const initialState = {
    "active": true,
    "list": null,
    "edited" :null,
    "topUsersWithDailyCount": [],
}

export default initialState;